<template>
  <section>
    <TitleBar>
      Bons de commande appro
      <template #toolbar-content>
        <TableButtonGroup
          :tableKey="tableKey"
          @rechercher="rechercher"
        ></TableButtonGroup>
      </template>
    </TitleBar>
    <b-container fluid>
      <ErrorComponent :error="error" @hide="error = null"></ErrorComponent>
      <StrapiEditoComponent></StrapiEditoComponent>
      <PaginatedTable
        :fields="fields"
        :busy="busy"
        :pageable="pageable"
        :page="page"
        @change="pageableChanged"
      >
        <template #mobile-card="{ item }">
          <LigneCommandeApproCard :item="item"></LigneCommandeApproCard>
        </template>
        <template #cell(dateOperation)="{ item }">
          {{ isoSqlDateToFrenchDate(item.dateOperation) }}
        </template>
        <template #cell(quantiteCommandee)="{ item }">
          <MontantComponent :value="item.quantiteCommandee"></MontantComponent>
        </template>
        <template #cell(prixNet)="{ item }">
          <MontantComponent :value="item.prixNet"></MontantComponent>
        </template>
        <template #cell(montantHt)="{ item }">
          <MontantComponent :value="item.montantHt"></MontantComponent>
        </template>
        <template #cell(fichier)="{ item }">
          <DownloadComponent
            v-if="item.pieceJointe"
            :typeDocument="typeDocument"
            :targetId="item.numeroBon"
          ></DownloadComponent>
        </template>
      </PaginatedTable>
    </b-container>
  </section>
</template>

<script>
import TitleBar from "../../components/TitleBar.vue";
import TableButtonGroup from "../../components/controls/TableButtonGroup.vue";
import ErrorComponent from "../../components/ErrorComponent.vue";
import StrapiEditoComponent from "../../components/strapi/StrapiEditoComponent.vue";
import PaginatedTable from "../../components/PaginatedTable.vue";
import LigneCommandeApproCard from "../../components/cards/LigneCommandeApproCard.vue";
import MontantComponent from "../../components/MontantComponent.vue";
import DownloadComponent from "../../components/controls/DownloadComponent.vue";
import ExploitationService from "../../services/exploitation.service";
import { TableKeys } from "../../store/tables.defaults";
import {
  dataFactory as tableDataFactory,
  created,
  computed as tableComputed,
  methods as tableMethods,
} from "../../services/tables.service";
import UtilsService from "../../services/utils.service";
export default {
  name: "BonsCommandeApproView",
  components: {
    TitleBar,
    TableButtonGroup,
    ErrorComponent,
    StrapiEditoComponent,
    PaginatedTable,
    LigneCommandeApproCard,
    MontantComponent,
    DownloadComponent,
  },
  data() {
    return {
      ...tableDataFactory(TableKeys.BONS_COMMANDE_APPRO),
      typeDocument: this.$store.state.expl.typesDocument.BON_COMMANDE_APPRO,
      error: null,
      page: null,
    };
  },
  computed: {
    ...tableComputed,
    exploitationCourante() {
      return this.$store.getters["expl/adherentCourant"];
    },
  },
  created,
  mounted() {
    this.load();
  },
  methods: {
    ...tableMethods,
    isoSqlDateToFrenchDate: UtilsService.isoSqlDateToFrenchDate,
    async load() {
      this.error = null;
      try {
        this.busy = true;
        let response = await ExploitationService.getBonsCommandeAppro(
          this.exploitationCourante.codeTiers,
          this.getSearchPayload()
        );
        this.page = response.data;
      } catch (error) {
        this.page = null;
        this.error = UtilsService.handleError(error);
      } finally {
        this.busy = false;
      }
    },
  },
};
</script>
